<template>
  <FontAwesomeIcon
    :icon="[prefix, name]"
    :class="classIcon"
    fixed-width
    size="3x"
    v-bind="$attrs"
  />
</template>

<script>
import { computed } from '@vue/composition-api'

import {
  ART,
  ART_DEFAULT,
  COLOR,
  COLOR_DEFAULT,
  SIZE,
  SIZE_DEFAULT,
} from './constants'
import FontAwesomeIcon from './fontAwesomeIcon'

const validate = propType => val => {
  return Object.keys(propType).includes(val)
}

const artToPrefixMap = {
  solid: 'fas',
  light: 'fal',
  thin: 'fat',
}

export default {
  name: 'Icon',

  components: { FontAwesomeIcon },
  inheritAttrs: false,

  props: {
    art: {
      type: String,
      default: ART_DEFAULT,
      validator: validate(ART),
    },

    color: {
      type: String,
      default: COLOR_DEFAULT,
      validator: validate(COLOR),
    },

    size: {
      type: String,
      default: SIZE_DEFAULT,
      validator: validate(SIZE),
    },

    name: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const prefix = computed(() => artToPrefixMap[props.art])
    const classIcon = computed(() => [
      `c-${COLOR[props.color]}`,
      `s-${SIZE[Number(props.size)]}`,
    ])

    return { prefix, classIcon }
  },
}
</script>

<style lang="postcss" scoped>
.s-12 {
  font-size: 12px;
}

.s-16 {
  font-size: 16px;
}

.s-18 {
  font-size: 18px;
}

.s-20 {
  font-size: 20px;
}

.s-24 {
  font-size: 24px;
}

.s-32 {
  font-size: 32px;
}

.c-lightGreen {
  color: var(--c-light-green);
}
.c-green {
  color: var(--c-green);
}
.c-lightGrey {
  color: var(--c-light-grey);
}
</style>
